/*
 * Pie de página del live portado (sections/skindion-live-footer.liquid).
 * Reemplaza a footer-section de Getmore 5.3.0 (js-layout.js): hasta 880 px las columnas de enlaces
 * se vuelven acordeones (título con + / −).
 */
(() => {
  const MOBILE = window.matchMedia('(max-width: 880px)');
  const COLLAPSE = 'sl-footer-collapse';

  class SkindionLiveFooter extends HTMLElement {
    connectedCallback() {
      this.columns = Array.from(this.querySelectorAll('.sl-footer-column-links'));
      if (this.columns.length === 0) return;

      this.columns.forEach((column) => {
        const title = column.querySelector('.sl-footer-column-title');
        if (!title) return;
        title.addEventListener('click', () => {
          if (!column.classList.contains(COLLAPSE)) return;
          const isOpen = column.classList.toggle('active');
          title.setAttribute('aria-expanded', String(isOpen));
        });
        title.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          if (!column.classList.contains(COLLAPSE)) return;
          event.preventDefault();
          title.click();
        });
      });

      this.onBreakpoint = this.onBreakpoint.bind(this);
      this.onBreakpoint(MOBILE);
      MOBILE.addEventListener('change', this.onBreakpoint);
    }

    disconnectedCallback() {
      if (this.onBreakpoint) MOBILE.removeEventListener('change', this.onBreakpoint);
    }

    /** @param {MediaQueryList | MediaQueryListEvent} media */
    onBreakpoint(media) {
      this.columns.forEach((column) => {
        const title = column.querySelector('.sl-footer-column-title');
        column.classList.toggle(COLLAPSE, media.matches);
        if (!title) return;
        if (media.matches) {
          title.setAttribute('role', 'button');
          title.setAttribute('tabindex', '0');
          title.setAttribute('aria-expanded', String(column.classList.contains('active')));
        } else {
          title.removeAttribute('role');
          title.removeAttribute('tabindex');
          title.removeAttribute('aria-expanded');
        }
      });
    }
  }

  if (!customElements.get('skindion-live-footer')) customElements.define('skindion-live-footer', SkindionLiveFooter);
})();
